import { startCase } from 'lodash';
import { Label, Slider, Select } from '@/components/FormElements';
import Button from '@/components/Button';
import RevealPill, { PillSwitch } from '@/components/Editor/Form/fields/RevealPill';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import sliderStyles from '@/components/FormElements/Slider/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SLIDER_MIN = 0;
const SLIDER_MAX = 10;
const DEFAULT_ENABLED = true;
const DEFAULT_DURATION = 1000;
const DEFAULT_EASING = 'linear';
const EASING_OPTIONS = ['linear', 'easeInQuad', 'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic', 'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint', 'easeInOutQuint', 'easeInSine', 'easeOutSine', 'easeInOutSine', 'easeInExpo', 'easeOutExpo', 'easeInOutExpo', 'easeInCirc', 'easeOutCirc', 'easeInOutCirc', 'easeInElastic', 'easeOutElastic', 'easeInOutElastic', 'easeInBack', 'easeOutBack', 'easeInOutBack', 'easeInBounce', 'easeOutBounce', 'easeInOutBounce'];

const valueFormatter = value => `${value}s`;

const EditorFormFieldsAnimation = _ref => {
  let {
    nameSpace,
    animation = {},
    defaults = {},
    hasEasing = true,
    openButtonVariant,
    onChange
  } = _ref;
  const durationFieldId = `${nameSpace}-duration`;
  const delayFieldId = `${nameSpace}-delay`;
  const easingFieldId = `${nameSpace}-easing`;
  const defaultDuration = (animation.duration ?? defaults.duration ?? DEFAULT_DURATION) / 1000; // convert to seconds

  const defaultDelay = (animation.delay ?? defaults.delay ?? 0) / 1000; // convert to seconds

  const isModified = (typeof animation.enabled === 'undefined' || animation.enabled) && ['duration', 'delay', 'easing'].some(key => {
    return animation[key] !== undefined;
  }); // Default slider marks for duration and delay

  const marks = {
    [SLIDER_MIN]: valueFormatter(SLIDER_MIN),
    [SLIDER_MAX]: valueFormatter(SLIDER_MAX)
  };
  const isEnabled = animation.enabled ?? DEFAULT_ENABLED;
  return /*#__PURE__*/_jsx(RevealPill, {
    label: "Animation",
    disableOpen: !isEnabled,
    openButtonVariant: openButtonVariant,
    activeState: /*#__PURE__*/_jsx(PillSwitch, {
      checked: isEnabled,
      onChange: checked => onChange({
        enabled: checked
      })
    }),
    noPadding: true,
    variant: isModified ? 'active' : '',
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.menu,
      children: [/*#__PURE__*/_jsx("p", {
        className: styles.description,
        children: "Customize the animation when chart loads or updates."
      }), hasEasing ? /*#__PURE__*/_jsx(Label, {
        forInput: easingFieldId,
        text: "Animation flow",
        className: parentStyles.formField,
        children: /*#__PURE__*/_jsx(Select, {
          id: easingFieldId,
          defaultValue: animation.easing || DEFAULT_EASING,
          onChange: evt => {
            onChange({
              easing: evt.currentTarget.value
            });
          },
          children: EASING_OPTIONS.map(value => /*#__PURE__*/_jsx("option", {
            value: value,
            children: startCase(value)
          }, `${nameSpace}-${value}`))
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(Label, {
        text: "Duration",
        children: /*#__PURE__*/_jsx(Slider, {
          className: sliderStyles.container,
          marks: marks,
          tipProps: {
            overlayClassName: sliderStyles.tooltip
          },
          defaultValue: defaultDuration,
          tipFormatter: valueFormatter,
          onChangeComplete: value => {
            onChange({
              duration: value * 1000
            });
          },
          step: 0.1,
          min: 0,
          max: 10
        }, durationFieldId)
      }), /*#__PURE__*/_jsx(Label, {
        text: "Delay",
        children: /*#__PURE__*/_jsx(Slider, {
          className: sliderStyles.container,
          marks: marks,
          tipProps: {
            overlayClassName: sliderStyles.tooltip
          },
          defaultValue: defaultDelay,
          tipFormatter: valueFormatter,
          onChangeComplete: value => {
            onChange({
              delay: value * 1000
            });
          },
          step: 0.1,
          min: 0,
          max: 10
        }, delayFieldId)
      }), isModified ? /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "delete",
        className: styles.deleteButton,
        onClick: () => onChange({
          delay: null,
          duration: null,
          easing: null,
          enabled: null
        }),
        children: "Reset animation"
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    })
  });
};

export default EditorFormFieldsAnimation;